'use strict';

import componentsModule from './core/module/mx-components.module.js';
import './core/model/enumerations.js';
import './core/services/mx-lazy-load-cfg-provider.js';
import './core/services/mx-data-provider-registry.js'; // Obsolete file. It is still here for backward compatibility of Workflows/Extensions based on old template.
import './core/utils';

import './directives/mx-bind-html-compile/mx-bind-html-compile.js';
import './directives/mx-bind-html-trusted/mx-bind-html-trusted.js';
import './directives/mx-drag-n-drop/mx-drag-n-drop.js';
import './directives/mx-form-validation/mx-form-validation.js';
import './directives/mx-hover-class/mx-hover-class.js';
import './directives/mx-lazy-load/mx-lazy-load.js';
import './directives/mx-mask/masks/mx-color-mask.js';
import './directives/mx-mask/masks/mx-interval-mask.js';
import './directives/mx-mask/masks/mx-mask-base.js';
import './directives/mx-mask/mx-mask.directive.js';
import './directives/mx-mask/masks/mx-numeric-mask.js';
import './directives/mx-mask/masks/mx-regexp-mask.js';
import './directives/mx-on-outside-click/mx-on-outside-click.js';
import './directives/mx-prevent-menu-close/mx-prevent-menu-close.js';
import './directives/mx-repeater-complete/mx-repeater-complete.js';
import './directives/mx-repeater-item/mx-repeater-item.js';
import './directives/mx-resizable/mx-resizable.js';
import './directives/mx-right-click/mx-right-click.js';
import './directives/mx-transclude/mx-transclude.js';
import './directives/mx-ui-accessibility/mx-ui-accessibility.js';
import './mx-attachments/mx-attachment.component.ts';
import './mx-attachments/mx-attachments.js';
import './mx-attachments/mx-drop-zone.js';
import './mx-attachments/mx-zoom.js';
import './mx-button/mx-button.js';
import './mx-checkbox/mx-checkbox.js';
import './mx-choice/mx-choice.js';
import './mx-color-picker/mx-color-picker.js';
import './mx-config-reader/mx-config-reader.js';
import './mx-container/mx-container.js';
import './mx-currency/mx-currency.js';
import './mx-current-element/mx-current-element.js';
import './mx-datasource-paging-panel/mx-datasource-paging-panel.js';
import './mx-datasource-search-panel/mx-datasource-search-panel.js';
import './mx-date-time-picker/mx-date-time.js';
import './mx-dropdown-menu/mx-dropdown-menu.js';
import './mx-file-uploader/mx-file-uploader.js';
import './mx-form-errors/mx-form-errors.js';
import './mx-form-errors/mx-form-message.js';
import './mx-form/mx-form-control-base.js';
import './mx-form/mx-form.js';
import './mx-grid/mx-grid-color-picker.js';
import './mx-grid/mx-grid-currency.js';
import './mx-grid/mx-grid-date-time-picker.js';
import './mx-grid/mx-grid-edit-form-field.js';
import './mx-grid/mx-grid-edit-form.js';
import './mx-grid/mx-grid-icon-picker.js';
import './mx-grid/mx-grid-numeric-edit.js';
import './mx-grid/mx-grid-select.js';
import './mx-grid/mx-grid-helper.js';
import './mx-grid/mx-grid.js';
import './mx-hierarchy-picker/mx-hierarchy-picker.js';
import './mx-icon-picker/mx-icon-picker-dropdown.js';
import './mx-icon-picker/mx-icon-picker.js';
import './mx-icon/mx-icon.js';
import './mx-iframe/mx-iframe.js';
import './mx-image-preview/mx-image-preview.js';
import './mx-item-chooser/mx-item-chooser.js';
import './mx-list/mx-list.js';
import './mx-literals/mx-literal.js';
import './mx-numeric-edit/mx-numeric-edit.js';
import './mx-picker/mx-multi-picker.component.js';
import './mx-picker/mx-picker.component.js';
import './mx-picker/mx-select.component.js';
import './mx-quick-filter/mx-quick-filter.js';
import './mx-rating/mx-rating.js';
import './mx-repeater/mx-repeater.js';
import './mx-search-input/mx-search-input.js';
import './mx-stepper/mx-stepper.js';
import './mx-tabs/mx-tabs.js';
import './mx-text-area/mx-text-area.js';
import './mx-text-box/mx-text-box.js';
import './mx-timeline/mx-timeline-lazy.js';
import './mx-timeline/mx-timeline.js';
import './mx-treeview/mx-treeview.js';

export default componentsModule;
